import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import ContentPageTemplate from "../templates/contentpage.template"

const CountyTemplate = () => {
  let {
    contentfulContentPage: { mainContent, title },
  } = useStaticQuery(graphql`
    query loadPricesPage {
      contentfulContentPage(title: { eq: "Prices" }) {
        mainContent {
          json
        }
        title
      }
    }
  `)
  return <ContentPageTemplate pageContext={{ mainContent, title }} />
}

export default CountyTemplate
